<div class="text-center" *ngIf="loadError">
  <div class="alert alert-danger">Error loading form. Please refresh page and try again.</div>
</div>
<form #currentForm="ngForm" novalidate *ngIf="!loadError">
  <legend>{{ involvement.id ? 'Editing Involvement' : 'New Involvement' }}</legend>
  <hr class="mt-1 mb-2" />
  <div class="form-group">
    <label>Contact</label>
    <app-contact-search [contactId]="involvement.contact_id" [small_input]="false" (contact_id)="onContactSelect($event)" [editable]="!(involvement.contact_id && involvement.id) || newInvolvementForm"></app-contact-search>
    <div class="custom-control custom-control-inline custom-checkbox" (click)="involvement.include_spouse = !involvement.include_spouse">
      <input type="checkbox" name="include_spouse" [checked]="involvement.include_spouse" [(ngModel)]="involvement.include_spouse" class="custom-control-input" />
      <label class="custom-control-label">Include Spouse</label>
    </div>
    <div class="custom-control custom-control-inline custom-checkbox" (click)="involvement.include_employer = !involvement.include_employer">
      <input type="checkbox" name="include_employer" [checked]="involvement.include_employer" [(ngModel)]="involvement.include_employer" class="custom-control-input" />
      <label class="custom-control-label">Include Employer</label>
    </div>
  </div>
  <div class="form-group" *ngIf="involvement.contact_id">
    <div class="card mb-1">
      <div class="card-header">
        <button class="btn btn-secondary btn-sm pull-right float-right" type="button" (click)="clearAddresses()">Do not use</button>
        Addresses
      </div>
      <div class="card-body limited-height-extra-short">
        <div class="custom-controls-stacked">
          <div *ngFor="let address of contact_info.addresses" (click)="address.checked = !address.checked; addressSelect(address)" class="custom-control custom-checkbox">
            <input type="checkbox" [checked]="address.checked" [name]="'address-' + address.id" [(ngModel)]="address.checked" class="custom-control-input" />
            <label class="custom-control-label">{{ address.full_address }}</label>
          </div>
        </div>
      </div>
    </div>
    <div class="card mb-1">
      <div class="card-header">
        <button class="btn btn-secondary btn-sm pull-right float-right" type="button" (click)="clearEmailAddresses()">Do not use</button>
        Email Addresses
      </div>
      <div class="card-body limited-height-extra-short">
        <div class="custom-controls-stacked">
          <div *ngFor="let email_address of contact_info.email_addresses" (click)="email_address.checked = !email_address.checked; emailAddressSelect(email_address)" class="custom-control custom-checkbox">
            <input type="checkbox" [checked]="email_address.checked" [name]="'email_address-' + email_address.id" [(ngModel)]="email_address.checked" class="custom-control-input" />
            <label class="custom-control-label">{{ email_address.email }}</label>
          </div>
        </div>
      </div>
    </div>
    <div title="Use email address for automated documents(eg: oral deposition schedule)" (click)="involvement.use_email = !involvement.use_email" class="custom-control custom-checkbox mb-3">
      <input type="checkbox" [checked]="involvement.use_email" name="use_email" [(ngModel)]="involvement.use_email" class="custom-control-input" />
      <label class="custom-control-label">Use email address</label>
    </div>
    <div class="card mb-1">
      <div class="card-header">
        <button class="btn btn-secondary btn-sm pull-right float-right" type="button" (click)="clearPhoneNumbers()">Do not use</button>
        Phone Number
      </div>
      <div class="card-body limited-height-extra-short">
        <div class="custom-controls-stacked">
          <div *ngFor="let phone_number of contact_info.phone_numbers" (click)="phoneNumberSelect(phone_number)" class="custom-control custom-radio">
            <input type="radio" [checked]="phone_number.checked" [name]="'phone_number-' + involvement.contact_id" class="custom-control-input" />
            <label class="custom-control-label">{{ phone_number.display_name }}</label>
          </div>
        </div>
      </div>
    </div>
    <div title="Use phone for text notifications (eg: for reminders)" (click)="involvement.allow_phone_text = !involvement.allow_phone_text" class="custom-control custom-checkbox mb-3">
      <input type="checkbox" [checked]="involvement.allow_phone_text" name="allow_phone_text" [(ngModel)]="involvement.allow_phone_text" class="custom-control-input" />
      <label class="custom-control-label">Allow phone text</label>
    </div>
    <div class="card mb-1">
      <div class="card-header">
        <button class="btn btn-secondary btn-sm pull-right float-right" type="button" (click)="clearFaxNumbers()">Do not use</button>
        Fax Number
      </div>
      <div class="card-body limited-height-extra-short">
        <div class="custom-controls-stacked">
          <div *ngFor="let fax_number of contact_info.fax_numbers" (click)="fax_number.checked = !fax_number.checked; faxNumberSelect(fax_number)" class="custom-control custom-radio">
            <input type="radio" [checked]="fax_number.checked" [name]="'fax_number-' + involvement.contact_id" class="custom-control-input" />
            <label class="custom-control-label">{{ fax_number.display_name }}</label>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="form-group" *ngIf="form_options.role_types.length > 0">
    <app-multi-select-search
      label="Roles"
      [returnOnlyValue]="false"
      [searchOptions]="form_options.role_types || []"
      [selectedOptions]="selectedRoles || []"
      (selected)="setRoles($event)">
    </app-multi-select-search>
  </div>
  <div class="form-group">
    <label>Notes</label>
    <textarea class="form-control" name="notes" [(ngModel)]="involvement.notes"></textarea>
  </div>
  <div class="form-group">
    <label> Add Relationship </label>
    <input
      [(ngModel)]="relationSearchTerm"
      type="text"
      [data]="{ matter_id: involvement.matter_id }"
      [include_name]="true"
      [appAutocomplete]="'/involvements/autocomplete_contact_by_name'"
      (autocompleteSelect)="relationOnSelect($event)"
      placeholder="Search for involvement"
      class="form-control"
      name="relation-search"
    />
    <div class="card mt-1">
      <div class="card-header">
        Relationships -&nbsp;
        <app-badge badgeType="primary">{{ involvement.relationships.length }}</app-badge>
      </div>
      <div class="card-body limited-height-short">
        <div class="py-1 px-1" *ngFor="let relationship of involvement.relationships">
          <a class="pull-right float-right text-danger" href="javascript: void(0)" (click)="removeRelationship(relationship)">
            <i class="fas fa-times"></i>
          </a>
          <span>{{ relationship.label }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="form-group" *ngIf="!involvement.contact_id">
    <span class="text-danger">Please select a contact before saving</span>
  </div>
  <div class="form-row">
    <div class="col-6">
      <button type="button" class="btn btn-primary btn-block" [disabled]="formSubmitting" (click)="saveInvolvement(currentForm.form.valid)">
        {{ formSubmitting ? 'Saving' : 'Save' }}<span *ngIf="formSubmitting">&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
      </button>
    </div>
    <div class="col-6">
      <button type="button" class="btn btn-secondary btn-block" [disabled]="formSubmitting" (click)="cancelForm()">Cancel</button>
    </div>
  </div>
</form>
